// A module selection in the M&E balance panel is the path of node ids from a
// top-level pathway node down to the selected node.  Top-level nodes encode to
// just their own id, so a selection is interchangeable with a node id until an
// internal pathway node is picked.
const SEPARATOR = '::';

// figure space, so the indent lines up with the label text in a <select>
const INDENT = '\u2007\u2007';

export const encodeNodeSelection = path => path.join(SEPARATOR);

export const decodeNodeSelection = selection => (selection ? String(selection).split(SEPARATOR) : []);

export const isInternalNodeSelection = selection => decodeNodeSelection(selection).length > 1;

// the top-level pathway node a selection belongs to
export const getSelectionRootNodeId = selection => decodeNodeSelection(selection)[0];

/**
 * Flattens the node hierarchy from the case detail endpoint into <select>
 * options, indenting each level of internal pathway nodes beneath its parent.
 * Each level is sorted by label, matching the other module selects.
 */
export const getBalanceNodeOptions = (nodeHierarchy = [], depth = 0, ancestorIds = []) =>
  [...nodeHierarchy]
    .sort((a, b) => a.label.localeCompare(b.label))
    .flatMap(({ id, label, children = [] }) => {
      const path = [...ancestorIds, id];

      return [
        { value: encodeNodeSelection(path), label: `${INDENT.repeat(depth)}${label}` },
        ...getBalanceNodeOptions(children, depth + 1, path),
      ];
    });
